export default {
  MORE_LANG: '/episode/satisfaction/qs/lang',
  DETAIL: '/episode/satisfaction/qs/open',
  SUBMIT: '/episode/satisfaction/qs/submit'
}
